import type { RootAreaRow } from '../../repositoryblueprint/framework';

type Props = { items?: RootAreaRow[] };

export function RepositoryRootPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.path} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="font-mono text-sm font-medium text-brand-600">{item.path}</p>
            <span className="shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600 dark:bg-slate-800 dark:text-slate-300">
              {item.owner}
            </span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.purpose}</p>
        </div>
      ))}
    </div>
  );
}
